// extracted by mini-css-extract-plugin
export var auto = "_29-1";
export var spinner = "_29-0";